"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryMethodNames = void 0;
var DeliveryMethodNames;
(function (DeliveryMethodNames) {
    DeliveryMethodNames["PICKUP"] = "pickup";
    DeliveryMethodNames["DELIVERY"] = "delivery";
    DeliveryMethodNames["ON_THE_SPOT"] = "table";
})(DeliveryMethodNames = exports.DeliveryMethodNames || (exports.DeliveryMethodNames = {}));
